// useMyFaceStatus — best-effort read of GET /api/my/face-status for the
// home/profile banners. Any failure resolves to null (show nothing).
import { useEffect, useState } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import type { MyFaceStatus } from '@hub-wifi/shared'
import { getMyFaceStatus } from '../api/faceStatus'

export function useMyFaceStatus(): MyFaceStatus | null {
  const { getAccessTokenSilently } = useAuth0()
  const [status, setStatus] = useState<MyFaceStatus | null>(null)

  useEffect(() => {
    let cancelled = false
    async function load() {
      try {
        const token = await getAccessTokenSilently()
        const res = await getMyFaceStatus(token)
        if (!cancelled) setStatus(res.status)
      } catch {
        if (!cancelled) setStatus(null)
      }
    }
    void load()
    return () => {
      cancelled = true
    }
  }, [getAccessTokenSilently])

  return status
}
